export default __webpack_public_path__ + "static/media/4.a43555e4.png";